<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <!--ver para que el lazy validation xD -->
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs12 md12>
          <v-card max-width="100%" height="180">
            <v-card-text>Nivel: {{ nivel }}</v-card-text>
            <v-card-text>Tipo De Prueba: {{ tipoPrueba }}</v-card-text>
            <v-card-text>Documento: {{ documento }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md12>
          <v-layout>
            <v-flex lg12>
              <div v-if="loading">
                <loading></loading>
              </div>
              <v-spacer></v-spacer>
              <template>
                <v-data-table
                  :headers="headers"
                  :items="itemsDigitacion"
                  :rows-per-page-items="rowsPerPageItems"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                    <td class="text-xs-left">{{ props.item.serie }}</td>
                    <td class="text-xs-left">
                      {{ props.item.fechaDigitacion }}
                    </td>
                    <td class="text-xs-left">{{ props.item.fechaReporte }}</td>
                  </template>
                </v-data-table>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="descargaMasiva()">Descarga</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";

export default {
  name: "digitacion-data",
  components: {},
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: String,
    id: String,
  },
  data() {
    return {
      headers: [
        { text: "Curso", sortable: false, value: "codigoCurso" },
        { text: "Serie", sortable: false, value: "serie" },
        { text: "Fecha Digitacion", sortable: false, value: "fechaDigitacion" },
        { text: "Fecha Reporte", sortable: false, value: "fechaReporte" },
      ],
      itemsDigitacion: [],
      select: { nombre: "Sin asignar" },
      btnHidden: true,
      cardHidden: true,
      cardPrevHidden: true,
      dialogLoading: false,
      dialogGrid: false,
      filter: false,
      selectRol: false,
      itemsDocs: [],
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      asuntoDocumento: "",
      allowSpaces: false,
      codigo: "",
      contratoId: "",
      curso: "",
      nivel: "",
      tipoPrueba: "",
      documento: "",
      select: "",
      proceso: "",
      tipeArchive: "",
      filenameValue: "",
      filename: "",
      base64Value: "",
      codigo: "",
      visita: "",
      digitaciones: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  created() {
    this.tipeArchive = "*";
    this.user = this.$store.getters.userLogged.tipo;
    this.nivel = this.$route.params.idNivel;
    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.documento = this.$route.params.documento;
    this.contratoId = this.$store.getters.contratoStored;
    this.loadData();
  },
  mounted() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {},
  methods: {
    submit() {
      this.$v.$touch();
    },

    async loadData() {
      //this.id = this.$route.params.id;
      this.digitaciones = await this.loadDigitacion();
      this.itemsDigitacion = this.digitaciones.digitaciones;
    },

    async loadDigitacion() {
      this.contratoId = this.$store.getters.contratoStored;
      let body = {
        idNivel: this.nivel,
        tipoPrueba: this.tipoPrueba,
        documento: this.documento,
        idContrato: this.contratoId,
      };
      return await axios
        .post("/digitacion/getAllByFilter", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
  },
};
</script>
